import { getScheduleRulesInChartDisplayRange } from '~/modules/resourcing/common/chart/hooks/useAllocationTimelineBlocks2';
import { getTotalHoursForPeriodFromScheduleRules } from '~/modules/resourcing/common/util';
import { roundToDecimals } from '~/modules/resourcing/common/util/scheduleUtil';

export const getUserOverDistributionDetails = ({
  chartDisplayDateRange,
  chartDisplayPeriods,
  isPsaRmpTaskAllocation1Enabled,
  resourceAllocationScheduleRules,
  userTaskAllocationsSummaryScheduleRules
}) => {
  if (!isPsaRmpTaskAllocation1Enabled) return {};

  const {
    startDate: chartStartDate,
    endDate: chartEndDate
  } = chartDisplayDateRange;
  const resourceAllocationScheduleRulesInRange = getScheduleRulesInChartDisplayRange(
    {
      rangeStart: chartStartDate,
      rangeEnd: chartEndDate,
      scheduleRules: resourceAllocationScheduleRules || []
    }
  );
  const taskAllocationSummaryScheduleRulesInRange = getScheduleRulesInChartDisplayRange(
    {
      rangeStart: chartStartDate,
      rangeEnd: chartEndDate,
      scheduleRules: userTaskAllocationsSummaryScheduleRules || []
    }
  );

  if (
    !resourceAllocationScheduleRulesInRange?.length ||
    !taskAllocationSummaryScheduleRulesInRange?.length
  )
    return {
      userOverDistributedPeriodsMap: {},
      isUserTaskAllocationsOverDistributed: false
    };

  let isUserTaskAllocationsOverDistributed = false;

  const userOverDistributedPeriodsMap = chartDisplayPeriods.reduce(
    (acc, period) => {
      const { startDate, endDate } = period;

      const periodResourceAllocationTotalHours = getTotalHoursForPeriodFromScheduleRules(
        {
          start: startDate,
          end: endDate,
          scheduleRules: resourceAllocationScheduleRulesInRange
        }
      );

      const periodUserTaskAllocationTotalHours = getTotalHoursForPeriodFromScheduleRules(
        {
          start: startDate,
          end: endDate,
          scheduleRules: taskAllocationSummaryScheduleRulesInRange
        }
      );

      const periodProjectRemainingHours =
        roundToDecimals(periodResourceAllocationTotalHours) -
        roundToDecimals(periodUserTaskAllocationTotalHours);

      if (periodProjectRemainingHours < 0) {
        isUserTaskAllocationsOverDistributed = true;
        acc[startDate.toISO()] = {
          periodStartDate: startDate,
          periodEndDate: endDate
        };
      }

      return acc;
    },
    {}
  );

  return {
    userOverDistributedPeriodsMap,
    isUserTaskAllocationsOverDistributed
  };
};
